<template>
<Menu ref="sideMenu" :active-name="current" :open-names='[visitid]'
  accordion @on-select="changeItem" style="width: 100%;padding-bottom: 200px;">
  <MenuItem name="viewsubject">
    <Icon type="ios-globe"/> 概况
  </MenuItem>
  <Submenu :name="visit.id" v-for="visit in visits" :key="visit.id">
    <template slot="title">
      <Icon type="ios-folder-outline" /> <span>{{ visit.visit }}</span>
    </template>
    <MenuItem :name="state.id" v-for="state in groupStates(visit.id)" :key="state.id">
      <Icon type="ios-star-outline" v-if="state.status === 0" title="未填写"/>
      <Icon type="ios-star-half" v-if="state.status === 1" style="color: #4373ee;" title="填写中"/>
      <Icon type="ios-star" v-if="state.status === 2" style="color: green;" title="已完成"/>
      {{ state.domainName }}
    </MenuItem>
  </Submenu>
</Menu>
</template>

<script>
import { ListDomainStates } from '@/api/subject'

export default {
  name: 'domain-menu',
  data: function () {
    return {
      visits: [],
      visitid: this.state.visitid,
      states: []
    }
  },
  // watch: {
  //   current: function () {
  //     this.$nextTick(() => {
  //       console.log('watch')
  //       console.log('visitid:' + this.visitid)
  //       console.log('openNames:' + this.$refs.sideMenu.openNames)
  //       this.$refs.sideMenu.updateOpened()
  //       this.$refs.sideMenu.updateActiveName()
  //     })
  //   }
  // },
  created: function () {
    this.fetchData()
  },
  props: ['current', 'state', 'batch'],
  methods: {
    fetchData: function () {
      const query = { batch: this.batch }
      ListDomainStates(this.state.usubjid, query).then(async res => {
        this.states = res.states
        this.visits = res.visits
        this.updateMenu()
      })
    },
    updateMenu: function () {
      this.$nextTick(() => {
        this.$refs.sideMenu.updateOpened()
        this.$refs.sideMenu.updateActiveName()
      })
    },
    changeItem: function (name) {
      const studyid = this.$route.params.id
      this.visitid = name
      if (name === 'viewsubject') {
        this.$router.push({ path: '/study/' + studyid + '/subject/' + this.state.usubjid, query: { batch: this.state.batch } })
      } else {
        this.$router.push('/study/' + studyid + '/domain/' + name)
      }
    },
    groupStates: function (visitid) {
      return this.states.filter(function (item) {
        if (visitid === item.visitid) {
          return item
        }
      })
    }
  }
}
</script>
